import React from "react";
import ProblemImage from "../../images/problem.png";
import SolutionImage from "../../images/solution.png";

function ProblemAndSolution() {
  return (
    <div className="w-full px-6 sm:px-12 ">
      {/* Section 1: Image Left, Content Right */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">
        {/* Image */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={ProblemImage}
            alt="Problem"
            className="w-3/4 h-auto rounded-lg " // Reduced size
          />
        </div>
        {/* Content */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-3xl font-bold mb-4 text-gray-900">The Problem</h2>
          <p className="text-lg text-gray-700">
            Many traders struggle with managing their portfolios effectively,
            often missing out on opportunities due to lack of time or
            inefficient strategies.
          </p>
        </div>
      </div>

      {/* Section 2: Content Left, Image Right */}
      <div className="flex flex-col md:flex-row-reverse items-center justify-between gap-8">
        {/* Image */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={SolutionImage}
            alt="Solution"
            className="w-3/4 h-auto rounded-lg " // Reduced size
          />
        </div>
        {/* Content */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-3xl font-bold mb-4 text-gray-900">
            AlgoTurtle Solution
          </h2>
          <p className="text-lg text-gray-700">
            AlgoTurtle provides an AI-powered trading platform that automates
            your strategies, helping you make data-driven decisions and maximize
            your returns.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProblemAndSolution;
